import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import { FETCH_STATUSES, RESET_ACTION_TYPE } from 'resources'

import actions from './actions'

const initialState = {
  status: FETCH_STATUSES.NOOP,
  categories: [],
  rewards: [],
  currency: null,
  goal: {
    reward: null,
    amount: null,
  },
}

const reducer = (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case actions.fetchAll.INIT_TYPE: {
      return {
        ...state,
        status: FETCH_STATUSES.FETCHING,
      }
    }
    case actions.fetchAll.SUCCESS_TYPE: {
      return {
        ...state,
        status: FETCH_STATUSES.SUCCESS,
        categories: payload.categories,
        rewards: payload.rewards,
        currency: payload.currency,
      }
    }
    case actions.fetchAll.FAILURE_TYPE: {
      return {
        ...state,
        status: FETCH_STATUSES.FAILURE,
      }
    }
    case actions.setRedemptionGoal.INIT_TYPE: {
      return {
        ...state,
        status: FETCH_STATUSES.FETCHING,
      }
    }
    case actions.fetchRedemptionGoal.SUCCESS_TYPE: {
      return {
        ...state,
        status: FETCH_STATUSES.SUCCESS,
        goal: {
          ...state.goal,
          reward: payload.reward,
          amount: payload.amount,
        },
      }
    }
    case RESET_ACTION_TYPE: {
      return initialState
    }
    default:
      return state
  }
}

const persistConfig = {
  key: 'rewards',
  blacklist: [],
  storage,
}

export default persistReducer(persistConfig, reducer)
